<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Standard Payment Gateway Mapping</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <!-- <v-btn class="button" v-on="on" @click="this.dialog=true">Add Mapping</v-btn> -->
            <v-row justify="center">
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn class="button" v-on="on">Add Payment Gateway Mapping</v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="toolbar">
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <!-- {{ show_std }} {{ show_quota }}  {{ quota_list }} -->
                                <v-row>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                        <v-select dense rounded outlined :items="payment_gateway_details_list"
                                            item-text="merchantid" item-value="id"
                                            v-model="addedItem.paymentgatewaydetails"
                                            label="Select Merchant Id"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                        <v-select dense rounded outlined :items="payment_gateway_details_list"
                                            item-text="merchantid" v-model="editedItem.paymentgatewaydetails"
                                            label="Merchant Id"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1 && show_std == true">
                                        <v-autocomplete dense multiple rounded outlined :items="standard_list"
                                            item-text="name" item-value="id" v-model="addedItem.standard"
                                            label="Select Standard"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1 && show_std == true">
                                        <v-autocomplete dense rounded outlined :items="standard_list" item-text="name"
                                            v-model="editedItem.standard" label="Standard"></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                        <v-autocomplete dense rounded outlined :items="payment_gateway_type_list"
                                            item-text="name" item-value="id" v-model="addedItem.paymentgateway"
                                            label="Select Payment Gateway"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                        <v-autocomplete dense rounded outlined :items="payment_gateway_type_list"
                                            item-text="name" v-model="editedItem.paymentgateway"
                                            label="Select Payment Gateway"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                        <v-autocomplete dense rounded outlined :items="payment_type_list"
                                            item-text="name" item-value="id" v-model="addedItem.paymenttype"
                                            label="Select Payment Type"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                        <v-autocomplete dense rounded outlined :items="payment_type_list"
                                            item-text="name" v-model="editedItem.paymenttype"
                                            label="Select Payment Type"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1 && show_quota == true">
                                        <v-autocomplete dense rounded outlined :items="quota_list" item-text="name"
                                            item-value="id" v-model="addedItem.quota"
                                            label="Select Quota"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1 && show_quota == true">
                                        <v-autocomplete dense rounded outlined :items="quota_list" item-text="name"
                                            v-model="editedItem.quota" label="Select Quota"></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                        <v-checkbox dense v-model="editedItem.isactive" color="success"
                                            label="Active"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="button" @click="close">Cancel</v-btn>
                            <v-btn class="button" @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search"
                @current-items="getFiltered" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar flat dense color="white">
                        <v-spacer></v-spacer>

                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field>
                        <span style="width: 20px;"></span>
                        <!-- <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="button" v-on="on">Add Payment Gateway Mapping</v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="toolbar">
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete
                                                    dense
                                                    rounded
                                                    outlined
                                                    :items="payment_gateway_details_list"
                                                    item-text="merchantid"
                                                    item-value="id"
                                                    v-model="addedItem.paymentgatewaydetails"
                                                    label="Select Merchant Id"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-autocomplete dense rounded outlined :items="payment_gateway_details_list" item-text="merchantid" v-model="editedItem.paymentgatewaydetails" label="Merchant Id"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense multiple rounded outlined :items="standard_list" item-text="name" item-value="id" v-model="addedItem.standard" label="Select Standard"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-autocomplete dense rounded outlined :items="standard_list" item-text="name" v-model="editedItem.standard" label="Standard"></v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense rounded outlined :items="payment_gateway_type_list" item-text="name" item-value="id" v-model="addedItem.paymentgateway" label="Select Payment Gateway"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-autocomplete dense rounded outlined :items="payment_gateway_type_list" item-text="name" v-model="editedItem.paymentgateway" label="Select Payment Gateway"></v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="button" @click="close">Cancel</v-btn>
                                    <v-btn class="button" @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog> -->
                    </v-toolbar>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <!-- filters added here -->
                <template v-slot:top class="pb-5">
                    <v-row dense justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded
                                                    dense outlined color="#0F2027" :label="header.text" multiple
                                                    clearable :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>

    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {

    components: {
        Breadcrumbs,
    },

        data: () => ({
            overlay: false,
            errorMsg: {
                paymentgatewaydetails: false,
            },

            // extraBreadcrumbItems: [
            //     { text: "Standard Payment Gateway Mapping", disabled: true, href: "" },

            // ],
            

            breadcrumbClass: "breadcrumb-style1",
            snackbar_msg: "",
            color: "",
            org_id: null,
            snackbar: false,
            search: "",
            dialog: false,
            standard_payment_gateway_mapping: [],
            payment_gateway_details_list: [],
            payment_gateway_type_list:[],
            payment_type_list:[],
            standard_list: [],
            quota_list:[],
            show_std:null,
            show_quota:null,
            headers: [
                {
                    text: "Payment Gateway",
                    align: "left",
                    sortable: false,
                    value: "paymentgatewaydetails",
                },
                {
                    text: "Standard",
                    align: "left",
                    sortable: false,
                    value: "standard",
                },
                {
                    text: "Payment Gateway Type",
                    align: "left",
                    sortable: false,
                    value: "paymentgateway",
                },
                {
                    text: "Payment Type",
                    align: "left",
                    sortable: false,
                    value: "paymenttype",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
             filterArr: [],
            filters: {
                paymentgatewaydetails: [],
                standard: [],
                paymentgateway: [],
                paymenttype:[],
              //  isactive:[],
             // action:[],
      
    },
            editedIndex: -1,
            addedItem: {
                paymentgatewaydetails: null,
                quota:null,
                paymenttype:null,
                standard: [],
            },
            editedItem: {
                id: null,
                paymentgatewaydetails: null,
                paymentgatewaydetails_id:null,
                paymentgateway: null,
                paymenttype:null,
                standard: [],
                isactive: true,
                quota:null,
            },
            defaultItem: {
                id: null,
                paymentgatewaydetails: null,
                paymentgatewaydetails_id:null,
                paymenttype:null,
                paymentgateway: null,
                standard: [],
                isactive: true,
                quota:null,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Standard Payment Gateway Mapping" : "Edit Standard Payment Gateway Mapping";
            },
              bookList1() {
      return this.standard_payment_gateway_mapping.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        mounted() {
            this.onLoad();
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        methods: {
            initializeErrorMsgFalse() {
                this.errorMsg.paymentgatewaydetails = false;
            },
            getFiltered(e) {
              this.filterArr = e;
                            },
                             columnValueList(val) {
                             return this.standard_payment_gateway_mapping.map((d) => d[val]);
    },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AccountingAndFees/standardPaymentGatewayMapping")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.overlay = false;
                            this.standard_payment_gateway_mapping = res.data.standard_payment_gateway_mapping;
                            this.payment_gateway_details_list = res.data.payment_gateway_details_list;
                            this.payment_gateway_type_list = res.data.payment_gateway_type_list
                            this.standard_list = res.data.std_list;
                            this.quota_list = res.data.quota_list
                            this.show_quota = res.data.show_quota
                            this.show_std = res.data.show_std
                            this.payment_type_list = res.data.payment_type_list
                            if(res.data.show_quota==true){
                            if (this.headers.some((head) => head.value === "quota")) {
                            } else { this.headers.splice(4, 0, {
                                    text: "Quota",
                                    value: "quota",
                                    sortable: true,
                                })
                              }
                          }
                          if(res.data.show_std==true){
                            if (this.headers.some((head) => head.value === "standard")) {
                            } else { this.headers.splice(1, 0, {
                                    text: "Standard",
                                    value: "standard",
                                    sortable: true,
                                })
                              }
                          }
                            this.load = true;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.standard_payment_gateway_mapping.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.editedItem.paymentgatewaydetails == "" || this.editedItem.paymentgatewaydetails == null) {
                        this.showSnackbar("#b71c1c", "Please select Payment Gateway!!!");
                        return false;
                    }
                    // else if (this.show_std == true &&(this.editedItem.standard.length == 0 || this.editedItem.standard == null)) {
                    //     this.showSnackbar("#b71c1c", "Please select Standard!!!");
                    //     return false;
                    // } 
                    else if (this.show_quota == true &&(this.editedItem.quota == null)) {
                        this.showSnackbar("#b71c1c", "Please select quota!!!");
                        return false;
                    } else {
                        if (this.isValidated()) {
                            axios
                                .post("/AccountingAndFees/editStandardPaymentGatewayMapping", this.editedItem)
                                .then((res) => {
                                    if (res.data.msg == "200") {
                                        if (res.data.flag == "YES") {
                                            this.onLoad();
                                            this.showSnackbar("#4caf50", res.data.snackbar_msg); // show snackbar on success
                                        } else {
                                            this.onLoad();
                                            this.showSnackbar("#b71c1c", res.data.snackbar_msg);
                                        }
                                    }
                                })
                                .catch((error) => {
                                    window.console.log(error);
                                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                                })
                                .finally(() => {
                                    this.editedItem.paymentgatewaydetails = "";
                                    this.editedItem.standard = [];
                                });

                            this.close();
                        }
                    }
                } else {
                    if (this.addedItem.paymentgatewaydetails == "" || this.addedItem.paymentgatewaydetails == null) {
                        this.showSnackbar("#b71c1c", "Please select Payment Gateway!!!");
                        return false;
                    }

                    // if (this.show_std == true &&(this.addedItem.standard.length == 0 || this.addedItem.standard == null)) {
                    //     this.showSnackbar("#b71c1c", "Please Select Standard!!!");
                    //     return false;
                    // } 
                    else if (this.show_quota == true &&(this.addedItem.quota == null)) {
                        this.showSnackbar("#b71c1c", "Please Select Quota!!!");
                        return false;
                    } else {
                        axios
                            .post("/AccountingAndFees/saveStandardPaymentGatewayMapping", this.addedItem)
                            .then((res) => {
                                if ((res.data.flag = "YES")) {
                                    //   this.fees_component_list.push(this.addedItem);
                                    this.showSnackbar("#4caf50", res.data.snackbar_msg); // show snackbar on success
                                    this.onLoad();
                                } else if ((res.data.flag = "NO")) {
                                    this.showSnackbar("#b71c1c", res.data.snackbar_msg);
                                    // show snackbar on error
                                }
                            })

                            .catch((error) => {
                                window.console.log(error);
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            })
                            .finally(() => {
                                this.addedItem.paymentgatewaydetails = null;
                                this.addedItem.standard = [];
                            });

                        this.close();
                    }
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.paymentgatewaydetails) {
                    return true;
                } else {
                    if (!this.editedItem.paymentgatewaydetails) {
                        this.errorMsg.paymentgatewaydetails = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>

